import React from 'react'
import PropTypes from 'prop-types'
import StyledMenuItem from './StyledMenuItem'
import Copyright from '../../../components/Copyright'
import {
  DividerMenu,
  MenuItemWrap,
  DrawerHeader,
  StyledMenuDrawer
} from './styled-components'
import checkRole from '../../../utils/userRoles'
import AppConfig from '../../../utils/config'
import logo from '../../../images/logo_mysquare.svg'

// import AppConfig from '../../../utils/config'

const MenuDrawer = props => {
  const {
    docked,
    open,
    openProfileDrawer,
    onRequestChange,
    goMeetingRoomBooking,
    goMeetingRoomBackend,
    goStationeryBooking,
    goLeaveRequest,
    goMyColleagues,
    goLeaveRequestManager,
    goStaffsCalendar,
    goAdminTools,
    goPayslips,
    goHelp,
    goArticleManager,
    goHomepage,
    permissions,
    location
  } = props

  const { pathname } = location
  return (
    <StyledMenuDrawer
      zDepth={1}
      containerClassName="drawer-container"
      docked={docked}
      isProfileOpen={openProfileDrawer}
      open={open}
      onRequestChange={onRequestChange}>
      <DrawerHeader>
        <img src={logo} alt="MySquare Logo" onClick={goHomepage} />
      </DrawerHeader>
      <MenuItemWrap>
        <StyledMenuItem focused={pathname === '/'} onClick={goHomepage}>
          Homepage
        </StyledMenuItem>

        <StyledMenuItem
          focused={pathname === '/my-colleagues'}
          onClick={goMyColleagues}>
          My Colleagues
        </StyledMenuItem>
        <StyledMenuItem
          focused={pathname === '/meeting-room-booking'}
          onClick={goMeetingRoomBooking}>
          Meeting Room Booking
        </StyledMenuItem>

        {false &&
          checkRole(permissions, AppConfig.permissions.ManageMeetingRoom) && (
            <StyledMenuItem
              focused={pathname === '/admin/meeting-room-booking'}
              onClick={goMeetingRoomBackend}>
              Meeting Room
            </StyledMenuItem>
          )}

        <StyledMenuItem
          focused={pathname === '/leave-request/l'}
          onClick={goLeaveRequest}>
          Leave Request
        </StyledMenuItem>

        <StyledMenuItem
          focused={pathname === '/leave-request/manager'}
          onClick={goLeaveRequestManager}>
          Leave Request Manager
        </StyledMenuItem>

        <StyledMenuItem
          onClick={() =>
            window.open(
              'https://hcis.squaregroup.com.vn/ords/f?p=HRS_RECRUITMENT',
              '_blank'
            )
          }>
          Team Recruitment
        </StyledMenuItem>

        {/* <StyledMenuItem
          onClick={() =>
            window.open(
              'https://hcis.squaregroup.com.vn/ords/f?p=HRS_TRAINING_EMP',
              '_blank'
            )
          }>
          <b>Training & Development</b>
          <img
            src="/images/star.png"
            alt=""
            style={{ width: 15, marginBottom: 5 }}
          />
        </StyledMenuItem> */}

        <StyledMenuItem
          focused={pathname === '/staffs-calendar'}
          onClick={goStaffsCalendar}>
          Staff Calendar
        </StyledMenuItem>

        <StyledMenuItem
          focused={pathname === '/stationery-booking/s/'}
          onClick={goStationeryBooking}>
          Stationery Booking
        </StyledMenuItem>

        <StyledMenuItem focused={pathname === '/payslips'} onClick={goPayslips}>
          Payslips
        </StyledMenuItem>
        <StyledMenuItem focused={pathname === '/help'} onClick={goHelp}>
          Help
        </StyledMenuItem>

        <DividerMenu />

        {checkRole(permissions, AppConfig.permissions.ManageStationery) && (
          <StyledMenuItem
            focused={pathname === '/admin-tools'}
            onClick={goAdminTools}>
            Admin tools
          </StyledMenuItem>
        )}

        {checkRole(permissions, AppConfig.permissions.HumanCapital) && (
          <StyledMenuItem
            onClick={() =>
              window.open(
                'https://hcis.squaregroup.com.vn/ords/f?p=hrs_dashboard',
                '_blank'
              )
            }>
            Human Capital tools
          </StyledMenuItem>
        )}

        {checkRole(permissions, AppConfig.permissions.ManageCms) && (
          <StyledMenuItem
            focused={pathname === '/news-article/list'}
            onClick={goArticleManager}>
            Article Manager
          </StyledMenuItem>
        )}

        <Copyright color="#9b9b9b" fontSize="11px" />
      </MenuItemWrap>
    </StyledMenuDrawer>
  )
}

// AppConfig.permissions.ManageCms

MenuDrawer.propTypes = {
  docked: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  openProfileDrawer: PropTypes.bool.isRequired,
  onRequestChange: PropTypes.func,
  goMeetingRoomBooking: PropTypes.func.isRequired,
  goMeetingRoomBackend: PropTypes.func.isRequired,
  goStationeryBooking: PropTypes.func.isRequired,
  goLeaveRequest: PropTypes.func.isRequired,
  goMyColleagues: PropTypes.func.isRequired,
  goLeaveRequestManager: PropTypes.func.isRequired,
  goStaffsCalendar: PropTypes.func.isRequired,
  goAdminTools: PropTypes.func.isRequired,
  goPayslips: PropTypes.func.isRequired,
  goHelp: PropTypes.func.isRequired,
  goArticleManager: PropTypes.func.isRequired,
  goHomepage: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
}

export default MenuDrawer



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/MenuDrawer.js